export const bebasNeueFamily = 'Bebas Neue';
export const openSansFamily = 'Open Sans';
export const santoroScriptFamily = 'Santoro Script';
